import {IRecipeCalculationFieldsFragment} from "app/gql/graphqlSchema";
import {formatFractionPercent} from "app/util/stdlib";
import {FoodName} from "app/food/FoodSummary";
import {Fragment} from "react";

interface IProps {
  calculation: IRecipeCalculationFieldsFragment;
}
export const FinalRecipe = ({calculation}: IProps) => {
  const ingredients = calculation.ingredients;
  return (
    <div className="grid grid-cols-2 gap-2 border-collapse mt-4 max-w-fit">
      {ingredients.map((ingredient) => (
        <Fragment key={ingredient.ingredient.id}>
          <div className="p-1 border-b">
            <FoodName ingredient={ingredient.ingredient} />
          </div>
          <div className="p-1 border-b">{formatFractionPercent(ingredient.fraction)}%</div>
        </Fragment>
      ))}
    </div>
  );
};
